import React from "react";
import {Alert, Box, Button, CardHeader, InputAdornment, Stack, TextField} from "@mui/material";
import {RefreshOutlined as Refresh, SearchOutlined as Search} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {PageContainer} from "../components/common/page-container";
import {ContentContainer} from "../components/common/content-container";
import {useNotifications} from "./notification-context";
import useNotificationFeed from "./use-notification-feed";
import NotificationFeed, {NotificationFilters} from "./notification-feed";

export default function AllNotifications({navOpen}) {
    const center = useNotifications();
    return center?.enabled ? <NotificationHistory navOpen={navOpen}/> : null;
}

function NotificationHistory({navOpen}) {
    const center = useNotifications(), {t} = useTranslation();
    const feed = useNotificationFeed({size: 20});
    return <PageContainer navOpen={navOpen} sx={{minWidth: 0, width: "auto", flex: 1, boxSizing: "border-box",
        ml: {xs: 0, lg: navOpen ? "16%" : "6%"}, mr: 1}}>
        <CardHeader title={t("Notifications")} subheader={t("NotificationHistoryDescription")}/>
        <ContentContainer>
            <Stack direction={{xs: "column", sm: "row"}} spacing={2} sx={{p: 2}}>
                <TextField size="small" fullWidth value={feed.search} label={t("SearchNotifications")}
                    onChange={event => feed.setSearch(event.target.value)} inputProps={{maxLength: 200}}
                    InputProps={{startAdornment: <InputAdornment position="start"><Search fontSize="small"/></InputAdornment>}}/>
                <Button startIcon={<Refresh/>} onClick={() => {feed.refresh(); center.refreshCount();}} disabled={feed.loading}>{t("Refresh")}</Button>
                <Button sx={{flexShrink: 0}} onClick={center.markAll}
                    disabled={center.markingAll || center.pendingIds.size > 0 || center.count === 0}>{t("MarkAllAsRead")}</Button>
            </Stack>
            {center.countError && <Alert severity="warning">{t("NotificationCountUnavailable")}</Alert>}
            <Box sx={{px: 2}}><NotificationFilters feed={feed}/></Box>
            <NotificationFeed feed={feed} onOpen={center.openNotification}/>
        </ContentContainer>
    </PageContainer>;
}
